import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

//create slice
const name = "accountant";
const initialState = createInitialState();
const reducers = createReducer();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
  createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, reducers, extraReducers });

export const productStockAction = { ...slice.actions, ...extraActions };
export const productStockReducer = slice.reducer;

function createInitialState() {
  return {
    stockProductList: [],
  };
}

function createReducer() {
  return {
    clearStockProduct,
    setStockProductList,
  };
  function clearStockProduct(state, action) {
    state.warehouseNumber = null;
    state.category = null;
    state.productName = null;
    state.SKU = null;
    state.stockQuantity = null;
    state.cost = null;
    state.costTotal = null;
    state.gPartnerPrice = null;
    state.priceTotal = null;
  }

  function setStockProductList(state, action) {
    state.stockProductList = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Accountant`;
  return {
    getStockProductList: GetStockProductList(),
  };
  function GetStockProductList() {
    return createAsyncThunk(
      `${name}/GetStockProductDetails`,
      async () => await fetchWrapper.get(`${baseUrl}/GetStockProductDetails`)
    );
  }
}

function createExtraReducers(builder) {
  builder
      .addCase(extraActions.getStockProductList.pending, (state) => {
          state.isLoading = false; // Set loading state to false on pending
          state.error = ""; // Reset error message
      })
      .addCase(extraActions.getStockProductList.fulfilled, (state, action) => {
          state.stockProductList = action.payload || []; // Assign payload or fallback to an empty array
      })
      .addCase(extraActions.getStockProductList.rejected, (state, action) => {
          state.isLoading = true; // Set loading to true on error
          state.error = { error: action.error }; // Assign error state on rejection
      });
}